import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { trackBookingCtaClick, trackContact } from '../../utils/metaPixel';
import { scrollToBooking } from '../../utils/scrollToBooking';
// Fix for default marker icon in react-leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});
export function Location() {
  const {
    t
  } = useLanguage();
  const position: [number, number] = [34.0622, -118.3634]; // Wilshire Blvd, Beverly Hills area
  return <section className="py-20 lg:py-28 bg-white" data-id="element-232" data-mp="2ap2kftf0dfr">
      <div className="container mx-auto px-6" data-id="element-233" data-mp="2c0223ftuz12">
        <div className="grid lg:grid-cols-12 gap-16 lg:gap-24 items-center max-w-6xl mx-auto" data-id="element-234" data-mp="3jbgao2tv2mlo">
          <div className="lg:col-span-4" data-id="element-235" data-mp="3o9zw824jlwdi">
            <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-236" data-mp="3ob2qmk12qgy6">
              {t('location.eyebrow')}
            </span>
            <h2 className="text-4xl md:text-5xl font-serif font-light text-brand-dark mb-12 tracking-tight" data-id="element-237" data-mp="163awh7wnf98">
              {t('location.heading')}
            </h2>

            <div className="space-y-10" data-id="element-238" data-mp="62u0pw9ihp7u">
              <div data-id="element-239" data-mp="b2y5ip124vi8">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-240" data-mp="b2gc005s4ve0">
                  {t('location.addressLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80 leading-relaxed" data-id="element-241" data-mp="jwb7egh3n7gg">
                  6404 Wilshire Blvd
                  <br data-id="element-242" data-mp="owh1s4er7828" />
                  Suite 610
                  <br data-id="element-243" data-mp="ttzg6abjifhm" />
                  Los Angeles, CA 90048
                </p>
              </div>

              <div data-id="element-244" data-mp="2px44vi79mhny">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-245" data-mp="2pwm3k75qxd96">
                  {t('location.salesPhoneLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80" data-id="element-246" data-mp="2zmx73slipkfj">
                  <a href="tel:+17026604534" onClick={() => trackContact({
                  channel: 'phone'
                })} className="hover:text-brand-dark transition-colors" data-id="element-247" data-mp="2zp9x8t1fj13o">
                    (702) 660-4534
                  </a>
                </p>
              </div>

              <div data-id="element-248" data-mp="3dmyhbynoa47o">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-249" data-mp="3dmgegj6i8rqs">
                  {t('location.clinicPhoneLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80" data-id="element-250" data-mp="1j8x9ioa5a6vg">
                  <a href="tel:+13106910066" onClick={() => trackContact({
                  channel: 'clinic_phone'
                })} className="hover:text-brand-dark transition-colors" data-id="element-251" data-mp="1jarto0dlduyh">
                    (310) 691-0066
                  </a>
                </p>
              </div>

              <div data-id="element-252" data-mp="3q37ozgmse1da">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-253" data-mp="3c59lj6a07pck">
                  {t('location.hoursLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80 leading-relaxed" data-id="element-254" data-mp="3h2j8mf9x7ox8">
                  {t('location.hours')}
                </p>
              </div>

              <div className="pt-4" data-id="element-255" data-mp="37782umghps1m">
                <button onClick={() => {
                trackBookingCtaClick('location');
                scrollToBooking();
              }} className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/70 hover:text-brand-dark transition-colors inline-flex items-center gap-2 border-b border-brand-gold/40 pb-1" data-id="element-256" data-mp="10g8mnti98dze">
                  {t('nav.cta')} →
                </button>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 h-[500px] lg:h-[600px] w-full rounded-[2rem] overflow-hidden border border-brand-stone/50 z-0" data-id="element-257" data-mp="2nioxq7si0htd">
            <MapContainer center={position} zoom={13} scrollWheelZoom={false} className="w-full h-full" data-id="element-258" data-mp="2ikndvkn90egu">
              <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png" data-id="element-259" data-mp="29qs94dq1gq1q" />
              <Marker position={position} data-id="element-260" data-mp="1zscew1vpt0o0">
                <Popup data-id="element-261" data-mp="1utj2kcs5zfpf">
                  Lipo Laser · Beverly Hills <br data-id="element-262" data-mp="1uut2l7ikuxyp" /> {t('location.address')}
                </Popup>
              </Marker>
            </MapContainer>
          </div>
        </div>
      </div>
    </section>;
}